import { t } from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getAuthConnection, getAuthConnections, postLogin, postLogout } from './data';
import { errorReceiveAuthConnection, errorReceiveAuthConnections, errorReceiveRemoveServerSideCookie, errorReceiveSetServerSideCookie, failedReceiveAuthConnection, failedReceiveAuthConnections, failedReceiveRemoveServerSideCookie, failedReceiveSetServerSideCookie, receiveAuthConnection, receiveAuthConnections, receiveRemoveServerSideCookie, receiveSetServerSideCookie } from './slice';
export function* requestAuthConnection(action) {
    const { email } = action.payload;
    try {
        const response = yield call(getAuthConnection, email);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveAuthConnection(error));
        }
        else if (data) {
            const { auth_connection: authConnection } = data;
            if (!authConnection) {
                yield put(errorReceiveAuthConnection(t('NO_USER_FOUND_MATCHING_EMAIL', {
                    email
                })));
            }
            yield put(receiveAuthConnection(authConnection));
        }
        else {
            throw new Error(t('NO_AUTH_CONNECTION_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveAuthConnection(e.message));
    }
}
export function* requestAuthConnections() {
    try {
        const response = yield call(getAuthConnections);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveAuthConnections());
        }
        else if (data && data.length > 0) {
            yield put(receiveAuthConnections(data));
        }
        else {
            throw new Error(t('NO_AUTH_CONNECTIONS_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveAuthConnections());
    }
}
export function* requestRemoveServerSideCookie(action) {
    try {
        const { consumerAPI } = action.payload;
        const response = yield call(postLogout, consumerAPI);
        if (!response || response.status !== 204) {
            yield put(errorReceiveRemoveServerSideCookie());
        }
        else {
            yield put(receiveRemoveServerSideCookie());
        }
    }
    catch (e) {
        yield put(failedReceiveRemoveServerSideCookie());
    }
}
export function* requestSetServerSideCookie(action) {
    try {
        const { auth0Authentication, consumerAPI } = action.payload;
        if (auth0Authentication !== undefined) {
            const { idToken } = auth0Authentication;
            const response = yield call(postLogin, idToken, consumerAPI);
            if (!response || response.status !== 204) {
                yield put(errorReceiveSetServerSideCookie());
            }
            else {
                yield put(receiveSetServerSideCookie());
            }
        }
        else {
            throw new Error(t('NO_AUTH0_AUTHENTICATION_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveSetServerSideCookie());
    }
}
export function* watchRequestAuthConnection() {
    yield takeLatest('auth0/requestAuthConnection', requestAuthConnection);
}
export function* watchRequestAuthConnections() {
    yield takeLatest('auth0/requestAuthConnections', requestAuthConnections);
}
export function* watchRequestRemoveServerSideCookie() {
    yield takeLatest('auth0/requestRemoveServerSideCookie', requestRemoveServerSideCookie);
}
export function* watchRequestSetServerSideCookie() {
    yield takeLatest('auth0/requestSetServerSideCookie', requestSetServerSideCookie);
}
